import { Gatekeeper } from '../model/gatekeeper';
import { GatekeeperList } from './../model/gatekeeper-list';
export class GatekeeperBuilder {
    static buildGatekeeper(data) {
        let gatekeeper = new Gatekeeper();
        gatekeeper.id = data.id;
        gatekeeper.name = data.name;
        gatekeeper.id_lot = data.id_lot;
        gatekeeper.public_url = data.public_url;
        gatekeeper.mode = data.mode;
        gatekeeper.auth = data.auth;
        gatekeeper.custom_function = data.custom_function;
        gatekeeper.delay = data.delay;
        gatekeeper.open_time = data.open_time;
        gatekeeper.product_type = data.product_type;
        gatekeeper.product_extra_type = data.product_extra_type;
        gatekeeper.warning_image = data.warning_image;
        gatekeeper.warning_message_es = data.warning_message_es;
        gatekeeper.warning_message_ca = data.warning_message_ca;
        gatekeeper.warning_message_fr = data.warning_message_fr;
        gatekeeper.warning_message_en = data.warning_message_en;
        gatekeeper.final_images = data.final_images;
        return gatekeeper;
    }
    static buildGatekeeperList(data) {
        const gatekeeperList = new GatekeeperList();
        gatekeeperList.pagination = data.pagination;
        gatekeeperList.page = data.page;
        gatekeeperList.totalCount = data.total;
        gatekeeperList.totalPages = data.total_pages;
        gatekeeperList.gatekeepers = _.map(data.gatekeepers, (gatekeeper) => {
            return this.buildGatekeeper(gatekeeper);
        });
        return gatekeeperList;
    }
}
//# sourceMappingURL=gatekeeper-builder.js.map